export default "__VITE_ASSET__e03e3779__"